import { convertPerformanceItems, convertMetricConfigs } from './performanceHelper';
import actionTypes from './performance.actionTypes';

const initialPerformanceMetricsState = {
    isFetching: false,
    data: {},
    config: {}
};

export function performanceMetrics(state = initialPerformanceMetricsState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_PERFORMANCE_METRICS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_PERFORMANCE_METRICS_SUCCESS: {
            const convertedMetricConfigs = convertMetricConfigs(action.performance_metric_configs);
            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                data: convertPerformanceItems(action.publication_perf, convertedMetricConfigs),
                config: convertedMetricConfigs
            });
            break;
        }
        default:
            nextState = state;
    }
    return nextState;
}

const initialPerformanceMetricFiltersState = {
    dateRange: {},
    metricTypeFilter: 'none'
};

export function performanceMetricFilters(state = initialPerformanceMetricFiltersState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.RECEIVE_PERFORMANCE_METRICS_SUCCESS:
            Object.assign(nextState, state, {
                dateRange: action.dateRange
            });
            break;
        default:
            nextState = state;
    }
    return nextState;
}